export default {
    greetings (state) {
      return state.greetings
    },

    selectedGreeting (state) {
        return state.selectedGreeting
    },

    getGreeting: state => (greetingId) => {
      return state.greetings.find(greeting => greeting.greetingId === greetingId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/greetings/getters.js